import React from 'react'
import { Loading } from './styles/Spinner.style'

const Spinner = ({ size }) => {
  return (
    <Loading size={size} />
  )
}

export default Spinner
